import ApiClient from '$lib/api';
import { menus } from '$lib/stores/store';
import { COMPONENTS } from '$lib/config/search-menu';

const api = new ApiClient();

export async function initMenus() {
    try {
        const data = await api.get('/api/menus');

        const result = (data || []).map(m => ({
            id: m.code,
            label: m.label,
            description: m.description,
            keywords: Array.isArray(m.keywords)
                ? m.keywords
                : (m.keywords || '').split(','),
            icon: m.icon,
            group: m.menu_group,
            visible: m.visible,
            type: m.menu_type,
            hotkey: m.hotkey,
            toolbar: m.toolbar,

            // iframe
            src: m.src,

            // component
            component: m.component,
            componentRef: COMPONENTS[m.component],
            collapseMenu: m.collapse_menu
        }));

        menus.set(result);
    } catch (err) {
        console.error('Lỗi initMenus:', err);
    }
}